import { Component } from '@theme/component';

/** @typedef {{back?: HTMLAnchorElement, coach?: HTMLInputElement, programme?: HTMLInputElement, programmeText?: HTMLElement}} EnquiryRefs */
/** Visible, editable coach/programme context. Native Shopify forms own validation and POST.
 * @extends {Component<EnquiryRefs>}
 */
class BroxCoachingEnquiry extends Component {
  /** @type {{coach: string, programme: string} | undefined} */
  #values;
  connectedCallback() { super.connectedCallback(); this.#context(); }
  updatedCallback() { super.updatedCallback(); this.#context(); }

  #context() {
    const params = new URLSearchParams(window.location.search);
    const limit = this.refs.coach?.maxLength > 0 ? this.refs.coach.maxLength : 250;
    this.#values ??= { coach: (params.get('coach') ?? this.refs.coach?.value ?? '').trim().slice(0, limit), programme: (params.get('programme') ?? this.refs.programme?.value ?? '').trim().slice(0, limit) };
    if (this.refs.coach) this.refs.coach.value = this.#values.coach;
    if (this.refs.programme) this.refs.programme.value = this.#values.programme;
    this.#updateContext();
    const back = params.get('back');
    if (!back || !this.refs.back) return;
    try {
      const destination = new URL(back, window.location.origin);
      if (destination.origin === window.location.origin && /^\/(pages|products)\//.test(destination.pathname)) this.refs.back.href = destination.href;
    } catch { /* Retain the merchant-selected destination for malformed context. */ }
  }

  #updateContext() {
    if (this.refs.programmeText) this.refs.programmeText.textContent = this.#values?.programme || this.dataset.programmeFallback || '';
    // Keep the alternate template and the currently edited names through native redirects.
    const returnInput = this.querySelector('input[name="return_to"]');
    if (!(returnInput instanceof HTMLInputElement)) return;
    const destination = new URL(window.location.href);
    if (this.#values?.coach) destination.searchParams.set('coach', this.#values.coach);
    else destination.searchParams.delete('coach');
    if (this.#values?.programme) destination.searchParams.set('programme', this.#values.programme);
    else destination.searchParams.delete('programme');
    destination.searchParams.set('contact_posted', 'true');
    destination.hash = this.querySelector('form')?.id ?? '';
    returnInput.value = destination.pathname + destination.search + destination.hash;
  }

  /** @param {Event} event - Keep visible context and native redirect values aligned with edits. */
  handleInput(event) {
    if (!(event.target instanceof HTMLInputElement) || (event.target !== this.refs.coach && event.target !== this.refs.programme)) return;
    this.#values = { coach: this.refs.coach?.value ?? '', programme: this.refs.programme?.value ?? '' };
    this.#updateContext();
  }
}
if (!customElements.get('brox-coaching-enquiry')) customElements.define('brox-coaching-enquiry', BroxCoachingEnquiry);
